import React from 'react';

const join = (...parts) => parts.join('');

function helpItems(items) {
  return (
    <div className="bsub-help-lines">
      {items.map((item) => (
        <div key={item.label}>
          <strong>{`${item.label}:`}</strong>
          {` ${item.text}`}
        </div>
      ))}
    </div>
  );
}

export const SUMMARY_HELP = {
  Total: join(
    'The total number of subscription keys for this brokerage, including assigned, ',
    'unused, expired, and keys converted to promo codes.',
  ),
  Assigned: join(
    'The total number of active subscriptions assigned to users, either directly to a ',
    'plan, using a subscription key to create a plan, or using a promo code to create a plan.',
  ),
  Expired: join(
    'The total number of subscriptions that have passed their expiry date and were ',
    'assigned to users, either directly to a plan, using a subscription key to create a ',
    'plan, or using a promo code to create a plan.',
  ),
  Remaining: join(
    'The total number of subscriptions still available for use, including unused ',
    'subscription keys and unused promo codes.',
  ),
  'Unused Subscriptions': join(
    'The total number of subscription keys that are still available, have not been ',
    'assigned, and have not been converted into promo codes. These keys can be used to ',
    'create a new plan, renew an existing plan, or convert to a promo code.',
  ),
  'Promo codes': join(
    'The total number of promo codes created under this brokerage, including active, ',
    'unused, and expired promo codes.',
  ),
  'Unused Promo codes': join(
    'The total number of unused subscriptions available within promo codes. These can be ',
    'used to create a new plan or renew an existing plan.',
  ),
  'Expired Promo Codes': join(
    'The total number of unused subscriptions within promo codes that have passed their ',
    'expiry date.',
  ),
  'Revoked Unused Promo Codes': join(
    'The total number of unused subscriptions within promo codes that have been revoked. ',
    'These unused subscriptions can be converted back to their original subscriptions. ',
    'Revoked promo codes cannot be used to create new plans, and plans previously created ',
    'using these promo codes will no longer be accessible.',
  ),
};

export const TAB_HELP = {
  subscription: join(
    'View all plans created using this brokerage’s subscriptions, including plans ',
    'assigned directly to users, plans created using a subscription key, and plans ',
    'created using a promo code.',
  ),
  assign: join(
    'Add users individually or upload multiple users at once, then send them an ',
    'invitation to sign up. Their details will be pre-filled during signup, and an ',
    'available subscription will be assigned automatically. If there are not enough ',
    'subscriptions available, the user will not be able to complete the signup process. ',
    'Once the user creates a plan, their details will move to the Subscriptions tab.',
  ),
  promoCode: join(
    'Subscriptions that have been converted into promo codes. A promo code has its own ',
    'expiry date, and access also depends on this brokerage’s subscription. If that ',
    'subscription expires, users cannot open their plans.',
  ),
};

export const SUBSCRIPTION_COLUMN_HELP = {
  status: helpItems([
    {
      label: 'Active',
      text: 'The subscription is active and the user can access the plan.',
    },
    {
      label: 'Expired',
      text: join(
        'The subscription has passed its expiry date and the user can no longer access ',
        'the plan.',
      ),
    },
    {
      label: 'Revoked',
      text: join(
        'Access to the plan has been revoked. The subscription remains assigned and can ',
        'be reinstated later.',
      ),
    },
  ]),
  promoCode: join(
    'The promo code used to create the plan. Filter this column to find one code. ',
    'A dash means no promo code was used.',
  ),
  plansUsed: 'How many plans this user has created under this brokerage’s subscriptions.',
  actions: helpItems([
    {
      label: 'Revoke',
      text: join(
        'Pauses the user’s access to the plan without removing the subscription assignment.',
      ),
    },
    {
      label: 'Reinstate',
      text: 'Restores access to a previously revoked subscription.',
    },
    {
      label: 'Renew',
      text: join(
        'Renews an expired plan and automatically assigns a new available subscription ',
        'to the plan.',
      ),
    },
  ]),
};

export const ONBOARDING_HELP = {
  status: join(
    'Awaiting invitation means no email has been sent yet. Invitation sent means an email ',
    'has gone out. You can send or resend more than once.',
  ),
  delete: join(
    'Delete this invitation? If they have not signed up, they can no longer use it. ',
    'Users who have already signed up are not affected.',
  ),
};

export const PROMO_COLUMN_HELP = {
  quantity: 'How many subscription keys were converted into this promo code.',
  remaining: 'How many of those keys have not been used to create a plan.',
  expiry: join(
    'The promo code’s own expiry date. Users also need this brokerage’s subscription to ',
    'stay active. If that subscription expires, they cannot open their plans.',
  ),
  cancel: join(
    'Returns unused quantity to this brokerage’s available subscriptions. If 50 were ',
    'created and 40 used, the remaining 10 are returned. Unused quantity on a revoked ',
    'promo code can be returned the same way.',
  ),
  revoke: 'Revokes access to every plan created with this promo code until access is reinstated.',
  reinstate: 'Restores access to plans created with this promo code.',
  status: join(
    'Active: the promo code can still be used. Expired: its date has passed. ',
    'Revoked: access to plans created with this code is paused.',
  ),
};

export const CREATE_PROMO_HELP = join(
  'Convert available subscription keys into a promo code that can be shared with multiple ',
  'users. The promo code can be used to create new plans or renew existing plans.',
);

export const PURCHASE_HELP = (
  <div className="bsub-help-lines">
    <div>
      {join(
        'You can purchase subscription keys directly from the ContinuityCoach website. ',
        'The keys will be emailed to you after purchase.',
      )}
    </div>
    <div>If you require an invoice, please contact us and we’ll be happy to provide one.</div>
    <div>Payments are processed through PayPal, including credit card payments.</div>
  </div>
);
